import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { EnhancedRoadmapDto } from '@cloudclevr/components';
import { API_ENDPOINTS } from '@api/ApiEndpoints';
import { useHttpClient } from '@hooks/utils/httpConfig';

// Hook for fetching a single roadmap by ID
export function useRoadmapQuery(roadmapId?: string): UseQueryResult<EnhancedRoadmapDto> {
  const client = useHttpClient();

  const fetchRoadmap = async (): Promise<EnhancedRoadmapDto> => {
    if (!roadmapId) {
      throw new Error('Roadmap ID is required');
    }  
    // Request recommendations along with their subCategory and costs
    const propsList = "Categories.Recommendations.SubCategory,Categories.Recommendations.Costs,Journals";
    const response = await client.get<EnhancedRoadmapDto>(
      API_ENDPOINTS.ROADMAPS_WITH_CATEGORIES(roadmapId, propsList)
    );

    return response;
  };

  return useQuery<EnhancedRoadmapDto, Error>({ queryKey: ['roadmap', roadmapId], queryFn: fetchRoadmap, 
      enabled: !!roadmapId,
      refetchOnWindowFocus: false,
      gcTime: 1000,
      staleTime: 1000,
    }
  );
}

export function useRoadmapStatus(): UseQueryResult<number> {
  const client = useHttpClient();

  const fetchStatus = async (): Promise<number> => {

    // Expect the endpoint to return a numeric status value
    const response = await client.get<number>(API_ENDPOINTS.ROADMAP_STATUS);
    return response;
  };

  return useQuery<number, Error>({ queryKey: ['roadmapStatus'], queryFn: fetchStatus, 
      enabled: true,
      refetchOnWindowFocus: true,
    }
  );
}